module.exports = __webpack_public_path__ + "static/img/game-cells.677d3c40.png";